import React from 'react';
import Modal from '@mui/material/Modal';
import Fade from '@mui/material/Fade';
import Grid from '@mui/material/Grid';
import { useStyles } from '../../../assets/jss/components/Modal/SimpleModal/simpleModalStyles';
import SmallButton from '../../Common/Components/smallButtonView';

export default function SimpleModal(props) {
  const classes = useStyles();
  const {
    children,
    open,
    handleOnClose,
    handleOnSubmit,
    title,
    subtitle,
    acceptBtnText,
    cancelBtnText,
    loading,
    blockClose
  } = props;

  return (
    <div>
      <Modal
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"
        className={classes.modal}
        open={open}
        onClose={blockClose ? undefined : handleOnClose}
        closeAfterTransition
        // BackdropComponent={Backdrop}
        // BackdropProps={{ classes: { root: classes.backDrop } }}
      >
        <>
          <Fade in={open}>
            <div className={classes.paper}>
              <h2 id="transition-modal-title">{title}</h2>
              <p id="transition-modal-description">{subtitle}</p>
              {children}
              <Grid container className={classes.buttonGrid}>
                <Grid item className={classes.buttonContainer}>
                  <SmallButton
                    label={acceptBtnText}
                    loading={loading}
                    color="light"
                    handleClick={handleOnSubmit}
                  />
                </Grid>
                {cancelBtnText !== null && cancelBtnText !== undefined && (
                  <Grid item className={classes.buttonContainer}>
                    <SmallButton
                      label={cancelBtnText}
                      loading={false}
                      color="white"
                      handleClick={handleOnClose}
                    />
                  </Grid>
                )}
              </Grid>
            </div>
          </Fade>
        </>
      </Modal>
    </div>
  );
}
